import { Redirect } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { MaturityValidate } from './components'
import { editMaturityIDCard } from 'quick-quote/product-sio/actions'
import { getCurrentMaturityIDCard, getErrorMaturityValidateMsg } from 'quick-quote/product-sio/selectors'
import { getSelectedDisplayProductCode, getSelectedDisplayProduct } from '../../product-selection/selectors'
import { isLoading } from 'quick-quote/ui/selectors'

export const MaturityValidateContainer = () => {
  const dispatch = useDispatch()
  const currentMaturityIDCard = useSelector(getCurrentMaturityIDCard)
  const errors = useSelector(getErrorMaturityValidateMsg)
  const isLoadingState = useSelector(isLoading)
  const selectedDisplayProductCode = useSelector(getSelectedDisplayProductCode)
  const selectedDisplayProduct = useSelector(getSelectedDisplayProduct)

  if (!selectedDisplayProductCode) {
    return <Redirect to="/" push />
  }

  return (
    <MaturityValidate
      currentMaturityIDCard={currentMaturityIDCard}
      errors={errors}
      isLoading={isLoadingState}
      selectedDisplayProductCode={selectedDisplayProductCode}
      selectedDisplayProduct={selectedDisplayProduct}
      editMaturityIDCard={(card) => dispatch(editMaturityIDCard(card))}
    />
  )
}
